// Angular
import {
    AfterViewInit, ChangeDetectorRef, Component,
    OnDestroy,
    OnInit,
    Input,Output,EventEmitter
} from "@angular/core"
import { MatSnackBar } from "@angular/material"
import { MatDialog } from "@angular/material/dialog"
import { ActivatedRoute, NavigationEnd, Router,Params } from '@angular/router'

import { StateService } from '../../../../../services/App/state.service'

import { DialogService } from '../../../../../services'
import { FormDialogComponent } from '../dialogs/form-dialog/form-dialog.component'

import _ from 'lodash'
// RxJS
import { of, Subscription } from 'rxjs'

// Layout



const KEY = "quickmenu"

@Component({
    selector: "atyl-nomade-quickmenu",
    templateUrl: "./quickmenu.component.html",
    styleUrls: ["./quickmenu.component.scss"],
})


export class  NomadeQuickMenuComponent implements OnInit {
    // constantes
    private TYPE_ACTION = 0;
    private TYPE_FORM = 1;
    
    @Output() onActionClosed = new EventEmitter<any>();
    @Input() urlQuickMenu: any = null;
    @Input() tiers: any
    @Input() dossier: any;
    @Input() visite: any;
    // Public properties
    droits: any = [];
    userDroits: any = [];
    user: any
    today: number = Date.now();
    title: string = "";
    desc: string = "";
    
    colorization: string = "";
    quickmenu: any[] = [];
    etats: any[] = [];
    url: string = "";
    id: string = "";
    currentState: any

    demande: any
    
    dossierWeb: any
    getCourrierFunc: any
    getImpressionFunc: any
    returnToDossierFunc: any
    createInstructionCompFunc: any
    
    creationCourrier: any
    addDocument: any
    creationFoyer: any
    creationFormDossierFunc: any
    creationFormMAMDossierFunc: any
    goToURL: any
    creationInstruction: any
    archiveDossier: any
    doublonDossier: any
    showAcces: any
    labelSub: any = "Actions";
    // new variables
    formulaires: any[] = [];
  //  @StringableValues(KEY)
    strings: any
    // Private properties
    private subscriptions: Subscription[] = [];
    /**
     * Component constructor
     *
     * @param subheaderService: SubheaderService
     */
    constructor(
		 private stateService: StateService,
		 private router: Router,
		 private dialogService: DialogService,
		
        private activatedRoute: ActivatedRoute,
       /*
        public subheaderService: SubheaderService,
       
        private appService: AppService,
        private stateService: StateService,
        public dialog: MatDialog,
        private cdf: ChangeDetectorRef,
        private utilities: UtilitaryService,
        private snackBar: MatSnackBar,
        private formulaireService: FormulaireService,
        private documentService: DocumentService,
        
        private consultationService: ConsultationService,
        private  pageConfigService: PageConfigService,
        private  dossierService: DossierService
        */
    ) { }
    ngOnInit() {
	    this.stateService.pages.subscribe((pages) => {
		    let routeConfig = ""
            let url: string = null;
            if(this.urlQuickMenu){
                url = this.urlQuickMenu
            }
            else if(this.activatedRoute && this.activatedRoute.routeConfig){
                url = this.activatedRoute.routeConfig.path;
            }
            if(url){
                console.log("Namede QuickMenuComponent menu pages",pages,this.dossier,url,this.activatedRoute)
                let _params={
                    
                }
                if (this.dossier && this.dossier.tiers)
                    _params["type"]= this.dossier.tiers.type;
                if (this.dossier)
                    _params["id"]= this.dossier.id;
                routeConfig="nomade_client/"+url
                this.handelAction(pages, routeConfig,_params)
            }
		})     
    }

	handelAction(pages: any, routeConfig: any, _params:any) {
        let grpButton=[];
        let grpWithoutButton=[];
        if(pages){
            pages.forEach((page) => {
              // console.log('page url action', page.url, routeConfig)
                if (page.url === routeConfig) 
                {
                      console.log('page ', page)
                    
                   /*
                    grpButton["PRINCIPAL"]={
                        libelle:"Principal",
                        children:[]
                    };
                    */
                    page.actions.forEach((action: any) => {
                         if (action.rights.r) {
                               //  console.log("action",action.tiers_type,routeConfig,_params)
                               if (action.sous_groupe) {
                                  
                                   if (grpButton[action.sous_groupe.key]==undefined)
                                       grpButton[action.sous_groupe.key]={
                                                    libelle:  action.sous_groupe.libelle,
                                                    children:[],
                                                    link: 'etats'
                                                };
                               } 
                           }
                    });     
                    
                    page.actions.forEach((action: any) => {
                        let button = action
                        if (action.rights.r) {
                             if (this.checkToAddButton(action.tiers_type,_params,button)) {   
                                 if (button.sous_groupe &&
                                    grpButton[button.sous_groupe.key]!=undefined) {
                                    grpButton[button.sous_groupe.key].children.push(button)
                               } else
                                    grpWithoutButton.push(button)
                           }     
                       }
                    })
                }
            })
        }
        this.quickmenu=grpWithoutButton;
        
       Object.values(grpButton).forEach((value: any) => {
          //console.log("grpButton",value);
          this.quickmenu.push(value);    
        });
      console.log("Namede QuickMenuComponent quickmenu",this.quickmenu);
        
    }
    
	checkToAddButton(tiers_type:any[],_params:any,button:any) {
        let added:boolean=true;
        if (_params.type!=undefined && tiers_type.length>0 ) {
            added=false;
            for(let i=0;i<tiers_type.length;i++) {
                if (tiers_type[i].type !=undefined
                  && tiers_type[i].type.code !=undefined
                 && tiers_type[i].type.code===_params.type)
                   added=true;
            }
           // console.log("checkToAddButton",added,tiers_type,_params.type,button)
        }
        return added;
        
    }
    
     CheckDroitsUser(): boolean {
        let response = true
        if (this.userDroits && this.userDroits.length > 0) {
            Object.keys(this.userDroits[0]).forEach((userDroitIndex) => {
                if (
                    this.router.url.toUpperCase().indexOf(userDroitIndex) !== -1
                ) {
                    response = this.userDroits[0][userDroitIndex].w
                }
            })
        }
        return response
    }
  	optionsIfNotEmpty(button: any) {
        return button.parametre.options ? button.parametre.options : ""
    }
    
  	action(button:any,dos:any) {
		console.log("QuicMenu click",button,dos);
		if (button.parametre) {
                        switch (button.parametre.action) {
	                        case "link":
                                this.router.navigate(["/home/" + button.parametre.url]); 
	                        	break
                            case "createForm":
                                 this.getFormulaire(button, this.optionsIfNotEmpty(button));
                                
                                break;

                            
                        }
                } else {
                       // console.log(button)
              		this.getFormulaire(button, '');
		}
	}
	
	 getFormulaire(button: any, page: any): void {
	    console.log("quickmenu getFormulaire",this.dossier,button.form)
        const formCopy = JSON.parse(JSON.stringify(button.form));
	    this.dialogService.open(FormDialogComponent, {
			data: {
				form: formCopy,
				title: button.form.form.libelle,
				dossier: this.dossier ? this.dossier : "",
				visite:this.visite ? this.visite : null
			},
			maximizable: true,
			minimizable: true,
			draggable: true,
			resizable: true,
			width: "80vw",
			height: "90vh"
		})
	    
        /*this.dialogService.open(
            FormDialogFormulaireWithSFComponent,
            {
                data: {
                    idAForm: button.IdForm,
                    dossier: this.dossier ? this.dossier : "",                    
                    create: true,
                    closeWhenValidate: true,
                    action: button,
                    v3: true,
                },
                height: "90vh",
                width: "90vw",
                draggable: true,
                resizable: true,
                minimizable: true,
                maximizable: true,
            }, (result: any) => {
                if (result.result) {
                    this.utilities.log("subhearder getFormulaire", result.result,page)
                   
                 	let _refresh={
						type: "formulaire",
						dossier: this.dossier,
						data:result.result
					};
                   
                    this.onActionClosed.emit(_refresh)
	                    
                    if (page.redirect!=undefined
                     && result.result.ID!=undefined) {
                        let _ops:any= {}
						
                        this.formulaireService
                        	.get(result.result.ID,_ops)
                        	.subscribe((dmform: JSONRpcResponse) => {
				              console.log("formulaire",dmform);
				              
				              if (dmform.result.demande!=undefined
				              && dmform.result.demande.dossier!=undefined
				              && dmform.result.demande.dossier.tiers!=undefined
				              && dmform.result.demande.dossier.tiers.type!=undefined
				               && dmform.result.demande.dossier.tiers.dossierID!=undefined
				              ) {
								let route:string="/home/"+page.redirect;
								route=route.replace(":type",dmform.result.demande.dossier.tiers.type);
					            route=route.replace(":id",dmform.result.demande.dossier.tiers.dossierID);
								console.log("formulaire route",route)
									 this.router.navigate([
				                            route
				                        ])
					
					
								}
				            
				          
				
				        })
                  }      
                }
            })
            */
    }
  

   
    
    
}
